import React from "react";
import IconBlueQuotes from "../icon-blue-quotes";
import styles from "./styles.css";
import PropTypes from "prop-types";

const QuoteBox = ({children}) => {
    return (
        <p styleName={"styles.quoteText"}>
            <span styleName={"styles.quoteLeft"}><IconBlueQuotes type="left"/></span>
            {children}
            <span styleName={"styles.quoteRight"}><IconBlueQuotes type="right"/></span>
        </p>
    );

};
QuoteBox.propTypes = {
    children: PropTypes.any
};
export default QuoteBox;
